/**
 * impersonation.js · v101.27.0 · «Entrar como» (solo Super Administrador).
 * Guarda la sesión del super_admin, entra con un token temporal del usuario elegido
 * (sin refresh) y permite volver a la cuenta propia en cualquier momento.
 */
import api from "./api";

export const IMP_BACKUP_KEY = "afc_imp_backup"; // { token, refresh, user }
export const IMP_INFO_KEY = "afc_imp";          // { session_id, expires_at, admin, reason, target }

export function getImpersonation() {
  try {
    const raw = localStorage.getItem(IMP_INFO_KEY);
    return raw && localStorage.getItem(IMP_BACKUP_KEY) ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export const isImpersonating = () => !!getImpersonation();

/** Restaura la sesión del super_admin (sin llamar al servidor). Devuelve true si había respaldo. */
export function restoreAdminSession(message) {
  try {
    const raw = localStorage.getItem(IMP_BACKUP_KEY);
    if (!raw) return false;
    const b = JSON.parse(raw);
    if (b.token) localStorage.setItem("afc_token", b.token);
    if (b.refresh) localStorage.setItem("afc_refresh", b.refresh);
    if (b.user) localStorage.setItem("afc_user", JSON.stringify(b.user));
    localStorage.removeItem(IMP_BACKUP_KEY);
    localStorage.removeItem(IMP_INFO_KEY);
    if (message) sessionStorage.setItem("afc_imp_msg", message);
    return true;
  } catch {
    return false;
  }
}

export async function startImpersonation(targetUser, reason) {
  if (isImpersonating()) throw new Error("Ya está «Entrando como» otro usuario. Vuelva primero a su cuenta.");
  const { data } = await api.post("/v1/auth/impersonate", { user_id: targetUser.id, reason, channel: "web" });
  const backup = {
    token: localStorage.getItem("afc_token"),
    refresh: localStorage.getItem("afc_refresh"),
    user: JSON.parse(localStorage.getItem("afc_user") || "null"),
  };
  localStorage.setItem(IMP_BACKUP_KEY, JSON.stringify(backup));
  localStorage.setItem(IMP_INFO_KEY, JSON.stringify({ ...data.impersonation, target: { name: data.user.name, email: data.user.email, role_display: data.user.role_display } }));
  localStorage.setItem("afc_token", data.access_token);
  localStorage.removeItem("afc_refresh"); // sin refresh: al vencer vuelve a la cuenta del admin
  localStorage.setItem("afc_user", JSON.stringify(data.user));
  window.location.href = "/apps";
}

export async function endImpersonation(message = "Volviste a tu cuenta.") {
  try { await api.post("/v1/auth/impersonate/end"); } catch { /* el token igual vence */ }
  restoreAdminSession(message);
  window.location.href = "/admin/usuarios";
}
